import React, {Component} from "react";
import {message, Upload, Modal, Popconfirm} from "antd";
import { UploadOutlined, FilePdfOutlined, CloseCircleOutlined} from '@ant-design/icons';
import * as yup from "yup";
import {isEmpty, map} from 'lodash';
import PreviewLetter from "../../../ProposalDetail/Component/Service/Proposal/PreviewLetter";
import Loader from "../../../../Common/Component/Loader";

class UploadAgreement extends Component {
  state = {
    product: '',
    model_code: '',
    description: '',
    date: '',
    amount: '',
    newAgreements: [],
    showPreview: false,
    btn_active: false,
    loader: false,
    offset: 0,
    limit: 5,
    total: 0
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // message.destroy();
    this.setState({ loader: false });

    // get list of service agreements
    if (Object.keys(nextProps?.CommercialCustomer?.serviceAgreementList).length > 0 &&
      JSON.stringify(nextProps?.CommercialCustomer?.serviceAgreementList?.results) !== JSON.stringify(this.state.newAgreements)) {
      this.setState({ newAgreements: nextProps?.CommercialCustomer?.serviceAgreementList?.results, total: nextProps?.CommercialCustomer?.serviceAgreementList?.count }, () => this.validate());
    }
  }

  // on previous click
  onPrev = () => {
    const {limit, offset} = this.state;
    const {getServiceAgreement, customerId} = this.props;
    if (offset !== 0) {
      const new_offset =  offset - (limit - 1)
      this.setState({offset: new_offset}, () => getServiceAgreement({customer_profile__uuid: customerId, offset: new_offset, limit}))
    }
  }

  // on next click
  onNext = () => {
    const {limit, offset, total} = this.state;
    const {getServiceAgreement, customerId} = this.props;
    if ((offset + limit) < total) {
      const new_offset =  offset + (limit)
      this.setState({offset: new_offset}, () => getServiceAgreement({customer_profile__uuid: customerId, offset: new_offset, limit}))
    }
  }

  // on clear
  onClear = () => {
    this.setState({newAgreements: []}, () => this.validate())
  }

  // get base 64 string
  getBase64String = (file = {}, cb) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = function () {
      cb(reader.result)
    }
  }

  // toggle pdf preview
  togglePreview = (value) => {
    if (this.state.showPreview !== value) {
      this.setState({showPreview: value})
    }
  }

  // on delete
  onDelete = (index) => {
    const {newAgreements} = this.state;
    if (newAgreements[index].uuid) this.props.deleteServiceAgreement(newAgreements[index]?.uuid)
    newAgreements.splice(index, 1)
    this.setState({newAgreements}, () => this.validate())
  }

  // validate required fields
  validate = () => {
    const {newAgreements} = this.state;

    const schema = yup.object().shape({
      newAgreements: yup.array(yup.object({
        service_agreement: yup.string().required('Url is required'),
        // name: yup.string().required('name is required')
      })).required("Agreements are required"),
    });

    const data = {newAgreements};

    setTimeout(() => {
      schema.validate(data, { abortEarly: false }).then(() => {
        this.setState({btn_active: true})
      }).catch(() => {
        this.setState({btn_active: false})
      });
    }, 500)
  }

  onUpload = () => {
    const {addServiceAgreement, getServiceAgreement, closeModal, customerId} = this.props;
    const {newAgreements, limit} = this.state;
    const arr = []
    map(newAgreements, (obj) => {
      if (!obj.uuid) {
        const arr = obj?.service_agreement?.split(';')
        const service_agreement = arr[0] + `;df:${obj?.name?.replace('.pdf', '')};` + arr[1]
        arr.push(addServiceAgreement({
          customer_profile_uuid: customerId,
          service_agreement
        }))
      }
    })

    Promise.all(arr).then((response) => {
      if (!isEmpty(response)) {
        getServiceAgreement({customer_profile__uuid: customerId, offset: 0, limit})
      }
      closeModal();
      this.onClear();
    })
  }

  onChange = (e) => {
    const {newAgreements} = this.state;
    const file = e?.file;
    if (file.status !== 'uploading') {
      file && this.getBase64String(file?.originFileObj, (result) => {
        newAgreements.push({service_agreement: result, name: file.name});
        this.setState({newAgreements, total: newAgreements.length}, () => this.validate())
      })
    }
  }

  renderAgreement = (item, index) => {
    let url = item?.service_agreement?.split('?') || [];
    let file_name = url?.[0]?.split('/')?.[url?.[0]?.split('/')?.length - 1]
    return(
      <div key={`coverLetter${index}`} className={'cover-letters'}>
        <div className="flex cvrow">
          <figure>
            <FilePdfOutlined className="fileprev" style={{height: 55, width: 50}}/>
          </figure>
          <div className="filedetail flex-1">
            <h4>{item?.name || file_name}</h4>
            <span className="action-link">
              <a href="/#" onClick={(e) => {e.preventDefault(); this.setState({selectedPDF: index}, () =>  this.togglePreview(true))}}><u>{'Preview'}</u></a> <a download={item.name} href={item.service_agreement} title='Download pdf document'><u>{'Download'}</u></a>
            </span>
          </div>
          <Popconfirm
            title="Are you sure?"
            onConfirm={() => this.onDelete(index)}
            okText="Yes"
            cancelText="No"
          >
            <CloseCircleOutlined />
          </Popconfirm>
        </div>                
      </div>
    )
  }

  render() {
    const {visible, closeModal} = this.props;
    const {btn_active, newAgreements, selectedPDF, showPreview, loader, total} = this.state;
    return (
      <div>
        {loader && <Loader />}
        <Modal
          title="Upload Service Agreement"
          visible={visible}
          onCancel={() => {this.onClear(); closeModal()}}
          footer={[
            <button key="cancel" className="btn btn-brand btn-bdr" onClick={() => {closeModal(); this.onClear()}}>Cancel</button>,
            <button key="upload" className={`btn ${btn_active ? 'btn-warning' : 'disabled'}`} onClick={() => this.onUpload()}>
            Upload</button>,
          ]}
        >
          <div  className="upld-agreement">
            <span className="avatar-uploader">          
              <Upload 
                name={'file'}
                onChange={this.onChange}
                // beforeUpload={() => false}
                accept=".pdf,application/pdf"
                showUploadList={false}
              >
                <p className="ant-upload-drag-icon">
                  <UploadOutlined />
                </p>
                <p>Drag and drop the service contract or <b>click here</b> to upload</p>
              </Upload>
            </span>
            <div className="">
              {
                map(newAgreements, this.renderAgreement)
              }
            </div>
          </div>
          {total > 0 ? <div className={'flex pagi-block'}>
            <a href={'/#'} className={'prev'} onClick={(e) => {e.preventDefault(); this.onPrev()}}>{`< Prev`}</a><a href={'/#'} className={'left'} onClick={(e) => {e.preventDefault(); this.onNext()}}>{`Next >`}</a>
          </div> : ''}
        </Modal>
        {showPreview && <PreviewLetter
          file={newAgreements[selectedPDF]?.service_agreement}
          visible={showPreview}
          handleCancel={() => this.togglePreview(false)} />}
      </div>
    );
  }
}

export default UploadAgreement;